import { useContext } from "react";
import { FileTypes, KindOfOrder } from "../../../../types/enums";
import { FileAttachmentsButton } from "../../../common";
import { PurchaseOrderContext, RefetchScope } from "../../purchase-order/context/PurchaseOrderContext";

export default function CreditMemoFilesButton() {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);

	return (
		<FileAttachmentsButton
			attachedFiles={order.details.files.filter(x => x.fileTypeID === FileTypes.CreditMemo)}
			orderID={order.details.purchaseOrderID}
			parentGuid={order.details.guid}
			kindOfOrder={KindOfOrder.PurchaseOrder}
			defaultFileType={FileTypes.CreditMemo}
			useFileTypes={false}
			onFileAdded={() => refetchOrder(RefetchScope.Files)}
			onFileDeleted={() => refetchOrder(RefetchScope.Files)}
		/>
	)
}
